import { Component, OnInit, Inject } from '@angular/core';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { Observable, fromEvent } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CountriesService } from 'src/app/services/apiclient/countries/countries.service';

@Component({
  selector: 'app-weights-table',
  templateUrl: './weights-table.component.html',
  styleUrls: ['./weights-table.component.css']
})

export class WeightsTableComponent implements OnInit {

  // Event resize
  eventHeight: Observable<any> = fromEvent(window, "resize");

  delivryAddress: any;
  isRelay: boolean;
  relay: any;

  countryCtrl: FormControl = new FormControl();

  countries: any;
  filteredCountries: Observable<any> | any;

  pos: any = this.tools.getStor("point_of_sale");
  shippingDatas: any = this.pos.shipping_costs;
  shippingCountries: any[] = [];

  currCosts: any;
  currCountry: any;

  displayedColumns: string[] = ['max_weight', 'shipping_price'];

  innerHeight: number = window.innerHeight;

  selectedIndex: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<WeightsTableComponent>,
    private tools: ToolsService,
    private countriesApi: CountriesService,
  ) {
    this.delivryAddress = data.delivryAddress;
    this.isRelay = data.isRelay;
    this.relay = data.relay;
  }

  ngOnInit() {

    /**
     * Quand la fenetre changera de hauteur 
     */
    this.onWindowResize();

    /**
     * On récupére les pays
     */
    this.countriesApi.getCountries().subscribe(
      countries => {

        this.countries = countries;

        /**
         * On trie les pays
         */
        this.parseCountries();

        /**
         * On set le mode par défaut
         */
        this.setDefaultMode();
        // this.setShippingModeByIndex(0);
        /**
         * On initialise l'écoute de l'input
         */
        this.getCountriesOnChange();
      }
    );

  }

  /**
   * @description Filtre les pays en fonction du nom en parametre
   * @param {sting} value
   * @returns {any[]} 
   */
  filterCountries(value: string): any[] {
    let filterValue = value.toLowerCase();
    return this.shippingCountries.filter(country => country.name.toLowerCase().indexOf(filterValue) === 0);
  }

  /**
   * @description Selectionne le mode par défaut (Qui correspond à l'adresse ou au point relay)
   */
  setDefaultMode(): void {

    /**
     * Le mode avec l'id 165 correspond au mode mondial relay
     */
    let targetMode = this.relay && this.isRelay ? { id: 165 } : this.delivryAddress.shipping_mode;

    for (let i = 0; i < this.shippingDatas.length; i++) {
      let mode = this.shippingDatas[i];

      if (mode.id === targetMode.id) {
        this.setShippingModeByIndex(i);
        this.selectedIndex = i;
        break;
      }

    }

  }

  /**
   * @description Récupération des pays éligibles
   * @returns {void}
   */
  parseCountries(): void {

    /**
     * On trie les pays
     */
    for (let a = 0; a < this.shippingDatas.length; a++) {
      let shippingRow = this.shippingDatas[a];

      for (let b = 0; b < shippingRow.countries.length; b++) {
        let country = shippingRow.countries[b];

        for (let c = 0; c < this.countries.length; c++) {
          let countryApi = this.countries[c];

          if (parseInt(countryApi.id) === parseInt(country.id) && !countryApi.isAlreadyIn) {
            this.shippingCountries.push(country);
            countryApi.isAlreadyIn = true;
            break;
          }

        }
      }
    }

    /**
     * On set le pays par défaut via l'adresse de livraison
     */
    if (this.delivryAddress) {

      for (let a = 0; a < this.shippingCountries.length; a++) {

        let country = this.shippingCountries[a];
        if (parseInt(country.id) === parseInt(this.delivryAddress.id_country)) {
          this.countryCtrl.setValue(country.name);
          this.currCountry = country;
          break;
        }

      }

    }

  }

  /**
   * @description Récupération ds pays quand l'input change
   * @returns {void}
   */
  getCountriesOnChange(): void {
    this.filteredCountries = this.countryCtrl.valueChanges
      .pipe(
        startWith(''),
        map(state => state ? this.filterCountries(state) : this.shippingCountries.slice()),
      );
  }

  /**
   * @description Ferme la dialog
   * @returns {void}
   */
  closeDial(): void {
    this.dialogRef.close();
  }

  /**
   * @description À la selection d'un mode d'expedition
   * @returns {void}
   */
  setShippingModeByIndex(index: any): void {
    this.currCosts = this.shippingDatas[index].costs;
  }

  /**
   * @description Quand la fenetre change de hauteur
   * @returns {void}
   */
  onWindowResize(): void {
    this.eventHeight.subscribe(event => {
      this.innerHeight = event.target.innerHeight;
    });
  }
  setCurrCosts($el?:any){
    
  }
}


